import { Box, ListItem, Tooltip, Typography } from "@mui/material";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { AttachmentIcon } from "../../../../attachments/AttachmentIcon";
import { EllipsisTypography } from "../../../../framework/Typography/EllipsisTypography";

export interface NewMessageAttachmentItemProps {
    attachment: IFileAttachment;
    onClick: (id: string) => void;
}

export const NewMessageAttachmentItem = ({ attachment, onClick }: NewMessageAttachmentItemProps) => (
    <ListItem
        key={attachment.id} onClick={(e) => { e.stopPropagation(); onClick(attachment.id); }}
        sx={{ padding: "2px 4px", cursor: "pointer" }}
    >
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Box display="flex" alignItems="center">
                <AttachmentIcon fileType={attachment.type} color="#fff" strokeColor="#848688" />
                <Box display="flex" flexWrap="wrap" alignItems="baseline" marginLeft="4px">
                    <Tooltip title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}>
                        <div>
                            <EllipsisTypography variant="caption" sx={{ marginLeft: "0.5rem", maxWidth: "275px", color: "text.secondary" }}>{attachment.name}</EllipsisTypography>
                        </div>
                    </Tooltip>
                    <Typography variant="caption" sx={{ marginLeft: "0.5rem" }}>{Base.intToFileSizeStr(attachment.size, false)}</Typography>
                </Box>
            </Box>
        </Box>
    </ListItem>
);
